import {
  API_GET_ACCOUNT,
  API_ACCOUNT_UPDATE,
} from './types';

import { buildApiRequest } from '@/modules/Vuex';

import apiClient from '@/modules/ApiClient';
import {
  accountById as apiAccountById,
  accountUpdate as apiAccountUpdate,
} from '@/api/routes/accounts';

const state = {
  isFetching: false,
  error: {},
};

const getters = {};

const mutations = {
  [API_ACCOUNT_UPDATE.REQUEST](state) {
    state.error = null;
    state.isFetching = true;
  },
  [API_ACCOUNT_UPDATE.SUCCESS](state) {
    state.error = null;
    state.isFetching = false;
  },
  [API_ACCOUNT_UPDATE.ERROR](state, error) {
    state.error = error;
    state.isFetching = false;
  },
};

const actions = {
  async [API_ACCOUNT_UPDATE.REQUEST]({ commit }, {
    account,
    name,
    logo,
  }) {
    try {
      commit(API_ACCOUNT_UPDATE.REQUEST);

      await apiClient.request({
        method: 'PUT',
        url: apiAccountUpdate,
        pathParams: {
          account: account.id,
        },
        data: {
          name,
          logo_64: logo,
        },
      });

      commit(API_ACCOUNT_UPDATE.SUCCESS);
    } catch (error) {
      commit(API_ACCOUNT_UPDATE.ERROR, error);
    }
  },
};

const settingsModule = {
  state,
  getters,
  mutations,
  actions,
};

buildApiRequest({
  storeModule: settingsModule,
  actionTypes: API_GET_ACCOUNT,
  apiRoute: apiAccountById,
});

export default settingsModule;
